import { DateUtils } from '@cuatroochenta/co-admin-react-library'
import { CustomResponse } from '../model/data/common'
import TaskBase from './TaskBase'
import Urls from './Urls'
import { Center } from '../model/domain/center'
import { Statistics } from '../model/domain/statistics'

export default class TaskStatistics extends TaskBase {
    public getStatistics(
        dateFrom: Date,
        dateTo: Date,
        centerId: Center['id'] | null
    ): Promise<Statistics[]> {
        const formattedRangeStartDate =
            DateUtils.formatDateForQueryString(dateFrom)
        const formattedRangeEndDate = DateUtils.formatDateForQueryString(dateTo)

        let url = `${Urls.URL_GET_STATISTICS}?date_from=${formattedRangeStartDate}&date_to=${formattedRangeEndDate}`
        if (centerId) {
            url += `&center_id=${centerId}`
        }

        return fetch(url, this.getRequestInfo())
            .then((response) => response.json())
            .then((response: CustomResponse<Statistics[]>) => {
                if (!response.success) {
                    throw new Error(response.error?.[0])
                }

                return response.data!
            })
            .catch((error) => {
                console.error('Error fetching statistics:', error)
                throw error
            })
    }
}
